<template>
	<div>
		<avue-form
			ref="formUnit"
			v-model="formUnit"
			v-loading="loading"
			:option="optionUnit"
			:upload-after="uploadAfter"
			:upload-before="onUploadBefore"
			@submit="submitUnit">
			<template slot="name">
				<el-autocomplete
					ref="unitName"
					v-model="formUnit.name"
					:debounce="0"
					:disabled="isAbleUnitName"
					:fetch-suggestions="querySearch"
					:trigger-on-focus="true"
					clearable
					placeholder="请填写 企业名称"
					style="width: 100%"
					@clear="onUnitNameClear"
					@select="unitChanged"></el-autocomplete>
			</template>
			<template slot="menuForm">
				<el-button v-if="isSubmitted" icon="el-icon-edit" @click="modifyUnit">修改</el-button>
			</template>

			<!--      <template slot="myDownLoadTemp">-->
			<!--        <el-button type="primary" @click="onDownLoadTemp">下载模板</el-button>-->
			<!--      </template>-->
		</avue-form>
		<geti-business-dialog ref="geti_dialog" @onGetiSure="onGetiSure"></geti-business-dialog>
		<jianzhu-hint-dialog ref="jianzhu_dialog" @onJianzhuHint="onJianzhuHint"></jianzhu-hint-dialog>
	</div>
</template>

<script>
import {checkUnit, getAreaList, getUnitHistory, getUnitInfoByLicense, uploadIdNoImg} from '@/api/insurance/policy'
import {getImgUrl} from '@/config/env'
import {industry_azx, unitOption} from '@/const/crud/insurance/unitOption'
import {openPdfUrl} from '@/util/util'
import GetiBusinessDialog from '@/components/insurance/getiBusinessDialog'
import {isAnZeProduct, isXsmJianzhu} from '@/util/productUtil'
import {insureMap} from '@/const/crud/insurance/product'
import JianzhuHintDialog from '@/components/insurance/jianzhuHintDialog'
import {addIdNoQuery} from 'meibao-insure/src/api/productCenterNew'

export default {
	name: 'UnitForm',
	components: {JianzhuHintDialog, GetiBusinessDialog},
	props: {
		productId: {
			type: Number | String,
			required: true,
		},
		unitType: {
			type: String,
			required: true,
		},
		showIndustry: {
			type: Boolean,
			default: false,
		},
		showCategory: {
			type: Boolean,
			default: false,
		},
		myInsureConfirm: {
			type: Object,
			default: () => {
				return {}
			},
		},
		insureTypeTemp: {
			type: Number | String,
			default: 0,
		},
		priceHintData: {
			type: Object,
			default: () => {
				return {
					totalPrice: 0,
					isEmployeeSubmitted: false,
				}
			},
		},
	},

	data: function () {
		return {
			optionUnit: this.deepClone(unitOption),
			formUnit: {
				certType: '',
				name: '',
				name1: '',
				principal: '',
				code: '',
				code1: '',
				mobile: '',
				industry: '',
				category: '',
				areaCode: '',
				address: '',
				license: '',
				example: 'images/yyzz_sl.jpg',
				identityFront: '',
				identityBack: '',
			},

			loading: true,
			isSubmitted: false,
			isAbleUnitName: false,
			//  历史网点
			unitList: [],
			selectOptions: [],
			insureType: this.insureTypeTemp,
			// priceHintData: this.priceHintData
			lastName: '',
			//投保人声明盖章文件下载地址
			downloadZhangFileUrl: '',
			isZhangCalc: false,
			isZhangUnit: false,
			//个体工商户 数据拆
			isNoYear: false,
			originData: {},
			templateData: {},

			//投保企业限制地区
			insureArea: '',
			addIdNoInterval: null,
			//识别出来的数据
			queryIdNoData: {},
		}
	},
	watch: {
		'formUnit.areaCode': {
			handler(val) {
				if (!this.validatenull(val)) {
					this.$nextTick(() => {
						this.$refs['formUnit'].validateField('areaCode')
					})
					// //判断 是否隐藏投保人声明盖章
					// if (!this.isZhangCalc) {
					//   this.showInsureConfirmProp(false)
					// }
				}
			},
		},
		'formUnit.certType': {
			handler(newVal, oldVal) {
				if (!this.validatenull(newVal) && newVal !== oldVal) {
					//处理证件类型
					if (this.insureType === 14) {
						this.onDealChangeCertType(newVal)
					}
				}
			},
			immediate: true,
		},
		'formUnit.name': {
			handler(val) {
				if (!this.validatenull(val)) {
					// //判断 是否隐藏投保人声明盖章
					// if (!this.isZhangCalc) {
					//   this.showInsureConfirmProp(false)
					// }
				}
			},
		},
		'formUnit.code': {
			handler(val) {
				if (!this.validatenull(val)) {
					// //判断 是否隐藏投保人声明盖章
					// if (!this.isZhangCalc) {
					//   this.showInsureConfirmProp(false)
					// }
				}
			},
		},
		showIndustry: {
			handler(val) {
				this.showIndustryProp(val)
			},
			immediate: true,
		},
		showCategory: {
			handler(val) {
				if (val) {
					//设置 信用代码规则
					this.setCodeRules()
				}
				this.showCategoryProp(val)
			},
			immediate: true,
		},
		//美亚 展示
		myInsureConfirm: {
			handler(val) {
				// if (!this.validatenull(val)) {
				//     this.showInsureConfirmProp(val)
				// }
			},
			immediate: true,
		},
		insureTypeTemp: {
			handler(val) {
				this.loading = false
				this.insureType = val
				if (this.insureType === 13) {
					//美亚 要加邮件
					// this.formUnit.example123 = 'images/yyzz_my.jpg'
					this.findObject(this.optionUnit.column, 'email').display = true
					// if (isMeiYaC(this.insureType, this.productId)) {
					//   this.findObject(this.optionUnit.column, 'insureConfirmFile').label = '投保重要事项确认书'
					// }
				} else if (this.insureType === 15) {
					// this.formUnit.example123 = 'images/yyzz_qh.jpg'
				} else if (this.insureType === 14) {
					//阳光驾意险，处理显示
					this.onDealOptionYg()
				} else if (this.insureType === 29) {
					//人保5-6类
					this.onDealOptionRb()
				}
				if (!this.validatenull(val)) {
					//设置区域dicData
					this.getAreaList()
				}
			},
			immediate: true,
		},
		priceHintData: {
			handler(val, old) {
				if (isAnZeProduct(this.insureType) && val.isEmployeeSubmitted) {
					if (val.totalPrice !== old.totalPrice || val.isEmployeeSubmitted !== old.isEmployeeSubmitted) {
						// this.priceHintData = val
						setTimeout(() => {
							if (val.totalPrice < 50000) {
								//小于5万，隐藏注册资金类数据
								this.isAnzeShowCustom(false)
							} else if (val.totalPrice < 200000) {
								//大于 5万，小于20万，则需要
								this.isAnzeShowCustom(true)
							} else {
								//大于20万，则显示身份证上传
								this.isJudgeShowCardImg(val.isEmployeeSubmitted)
							}
						}, 500)
					}
				}
			},
			deep: true,
		},
	},
	created() {
		this.init()
	},
	beforeDestroy() {
		this.onClearInterval()
	},
	methods: {
		init() {
			setTimeout(() => {
				this.loading = false
			}, 2000)
		},
		//获取dicData
		getAreaList() {
			getAreaList(3).then((response) => {
				let tempList = response.data.data
				let areaCode = this.findObject(this.optionUnit.column, 'areaCode')
				//获取投保地区

				this.insureArea = insureMap.get(this.insureType).insureArea || ''
				if (this.validatenull(this.insureArea)) {
					areaCode.dicData = tempList
				} else {
					let tempAreaList = tempList.find((itemData) => {
						return itemData.areaCode === this.insureArea
					})
					if (!this.validatenull(tempAreaList)) {
						areaCode.dicData = [tempAreaList]
					}
				}
			})
		},
		querySearch(queryString, cb) {
			// this.loading = true
			this.selectOptions = []
			let query = !this.validatenull(queryString) ? {unitName: queryString} : {}
			getUnitHistory(query)
				.then((response) => {
					if (!this.validatenull(response.data.data)) {
						this.unitList = response.data.data
						this.selectOptions = this.unitList.map((item) => {
							return {
								value: item.unitName,
							}
						})
					}
				})
				.catch(() => {})
				.finally(() => {
					// this.loading = false
					cb(this.selectOptions)
				})
		},
		unitChanged(val) {
			this.unitList.forEach((item) => {
				if (item.unitName == val.value) {
					this.formUnit.name = item.unitName
					this.formUnit.code = item.unitCode
					this.formUnit.principal = item.legalPerson
					this.formUnit.mobile = item.legalPersonMobile
					//判断如果地区不为空，并且在投保地区限制范围内
					if (this.validatenull(this.insureArea) || this.insureArea === `${item.areaCode.substr(0, 2)}0000`) {
						this.formUnit.areaCode = item.areaCode
					}
					this.formUnit.address = item.unitAddr
					this.formUnit.license = getImgUrl(item.busLicense)
					this.formUnit.industry = item.industry || ''
					if (isAnZeProduct(this.insureType)) {
						this.formUnit.category = item.category || ''
						this.formUnit.identityFront = item.identityFront || ''
						this.formUnit.identityBack = item.identityBack || ''

						this.formUnit.registerCapital = item.registerCapital || ''
						this.formUnit.termType = item.termType || ''
						this.formUnit.termStart = item.termStart || ''
						this.formUnit.termEnd = item.termEnd || ''
						this.formUnit.businessScope = item.businessScope || ''
					}
					this.$nextTick(() => {
						this.$refs['formUnit'].clearValidate()
					})
				}
			})
			//如果为安责险，则需要隐藏注册资本类 填写数据
			if (isAnZeProduct(this.insureType)) {
				this.optionUnit.column.forEach((itemData) => {
					let {prop, display} = itemData
					if (prop === 'registerCapital' || prop === 'termType' || prop === 'termStart' || prop === 'businessScope') {
						if (display) {
							itemData.display = false
						}
					}
				})
			}
		},
		//清空企业名称
		onUnitNameClear() {
			this.$refs.unitName.activated = true
			this.formUnit.name = ''
			this.$refs.unitName.getData('')
		},
		//提交企业信息
		submitUnit(form, done) {
			/*
       unitType：网点类型
       0--投保人、被保人
       1--投保人
       2--被保人
       3--共同被保人
       * */
			//如果是新市民 只给投广东地区，！！！
			if (!this.validatenull(this.insureArea) && form.code.length === 18) {
				//有地区限制
				let imgCode = form.code.slice(2, 4) + '0000'
				if (imgCode !== this.insureArea) {
					this.$alert('该保险产品仅限营业执照注册地为广东的企业投保', '提示')
					done()
					return
				}
			}
			//  校验网点信息
			let chkUnitInfo = {
				unitType: this.unitType,
				unitName: form.name,
				unitCode: form.code,
				unitAddress: form.address,
				areaCode: form.areaCode,
				legalPersonMobile: form.mobile,
				productId: this.productId,
				category: form.category || '',
				industry: form.industry || '',
				identityFront: form.identityFront || '',
				identityBack: form.identityFront || '',
			}
			//不需要
			// if (!this.validatenull(form.insureConfirmFile)) {
			//   chkUnitInfo.insureConfirmFile = form.insureConfirmFile
			// }
			if ((this.insureType === 14 || this.insureType === 29) && form.certType === '100') {
				//阳光驾意险，人保 并且为个人身份证
				chkUnitInfo.unitName = form.name1
				chkUnitInfo.unitCode = form.code1
				chkUnitInfo.certType = form.certType
			}
			//安泽电梯加默认值
			if (this.insureType === 18) {
				chkUnitInfo.industry = 'E'
				chkUnitInfo.category = 5
				chkUnitInfo.registerCapital = '200'
			}
			checkUnit(Object.assign(chkUnitInfo))
				.then(({data: {code, originCode, originData = {}, originMsg = '', data = '', params = {}}}) => {
					this.isNoYear = false
					if (code !== 0 || (originCode !== '200' && originCode !== '0')) {
						let {pid = ''} = params
						if (originCode === '205') {
							//重新提示，重新结算保费
							this.$confirm('营业执照地址为浙江、安徽、辽宁、重庆、河北地区的企业，请投保地区版。', '提示', {
								confirmButtonText: '确认投保地区版方案',
								cancelButtonText: '更改投保企业',
							})
								.then(() => {
									//替换productID,重新请求
									this.$emit('onChangeProductId', pid)
									setTimeout(() => {
										this.$refs.formUnit.submit()
									}, 100)
								})
								.catch(() => {
									done()
								})
							return
						} else if (originCode === '210') {
							//从地区版本切换到全国，则重新计算保费
							//替换productID,重新请求保费
							this.$emit('onChangeProductId', pid)
							setTimeout(() => {
								this.$refs.formUnit.submit()
							}, 100)
							return
						} else if (originCode === '499') {
							//引流 切换险种
							this.$emit('onChangeInure')
							done()
							return
						} else if (!originMsg.includes('您选择的企业暂时无法投保年单')) {
							this.$alert(originMsg, '提示', {}).then(() => {})
							done()
							return
						} else {
							this.isNoYear = true
						}
					}
					//赋值
					this.originData = originData

					//控制专票和普票
					let {taxType = ''} = originData
					this.$Bus.$emit('taxType', taxType)
					//控制投保人声明盖章
					originData.unitData = chkUnitInfo
					originData.interType = 'unit'
					this.$Bus.$emit('onBusFileConfirm', originData)

					if (this.validatenull(data)) {
						//没有值直接走企业判断
						this.onCheckUnitResult()
					} else {
						//获取数据
						let {result = {econKind: ''}} = JSON.parse(data)
						this.templateData = result
						if (result.econKind === '个体工商户') {
							this.$refs.geti_dialog.showGetiHint()
						} else {
							this.onCheckUnitResult()
						}
					}
				})
				.catch(function (error) {})
				.finally(() => {
					done()
				})
		},
		//判断拆出来写
		onCheckUnitResult() {
			//处理数据
			if (isAnZeProduct(this.insureType) && this.showCategory) {
				//安责险
				let tempCanShow = this.priceHintData.totalPrice >= 50000 && this.priceHintData.isEmployeeSubmitted
				this.optionUnit.column.forEach((itemData) => {
					let {prop, display} = itemData
					if (prop === 'registerCapital') {
						if (!display) {
							itemData.display = true
						}
						itemData.span = tempCanShow ? 12 : 24
					}
					if (prop === 'termType' || prop === 'termStart' || prop === 'businessScope') {
						if (!display && tempCanShow) {
							itemData.display = true
						} else if (display && !tempCanShow) {
							itemData.display = false
						}
					}
				})
				let isNeedInput = false
				let isReadyInput =
					this.validatenull(this.formUnit.termStart) || this.validatenull(this.formUnit.registerCapital)
				//判断值是否为空
				if (!this.validatenull(this.templateData)) {
					let {registCapi = '', termStart = '', termEnd = '', scope = ''} = this.templateData
					//如果需要显示，并且数据为空
					if (isReadyInput && this.priceHintData.totalPrice >= 50000) {
						//大于 50000
						//检测成功，填充数据
						if (termStart === '' || termEnd === '' || registCapi === '' || scope === '') {
							isNeedInput = true
						}
						this.formUnit.termStart = termStart
						this.formUnit.termEnd = termEnd === '-' ? '' : termEnd
						this.formUnit.termType = termEnd !== '' && termEnd === '-' ? 1 : 2
						this.formUnit.businessScope = scope
					}
					if (this.validatenull(this.formUnit.registerCapital)) {
						if (!this.validatenull(registCapi)) {
							registCapi = registCapi.replace(/[^0-9.]/gi, '')
						}
						if (this.validatenull(registCapi)) {
							isNeedInput = true
						} else {
							this.formUnit.registerCapital = registCapi
						}
					}
				} else {
					if (isReadyInput) {
						isNeedInput = true
					}
				}
				// let isNeedZhange = this.isJudgeZhang(false, false, 0)
				//如果大于50000，并且数据不完善，则需要手动填写
				if (isNeedInput && (tempCanShow || this.validatenull(this.formUnit.registerCapital))) {
					//检测失败，则需要手动填写
					this.$alert('根据规定：需要上传其他投保企业信息', '警告', {
						type: 'warning',
						confirmButtonText: '知道了',
					}).then(() => {
						//重新填写
					})
				} else {
					//数据获取成功
					this.checkOver()
				}
			} else {
				// let isNeed = this.isJudgeZhang(true, false, 0)
				// if (isNeed) {
				//   return;
				// }
				//如果是新市民建筑行业，则需要提示
				if (isXsmJianzhu(this.insureType)) {
					this.$refs.jianzhu_dialog.showJianzhuHint()
					return
				}
				//非安责险，则成功
				this.checkOver()
			}
		},
		//建筑提示
		onJianzhuHint(type) {
			if (type === 1) {
				//继续校验
				this.checkOver()
			}
		},
		// //判断是否需要上传盖章文件  0：企业，1：计算保费
		// isJudgeZhang(isShowHint = false, isNeedToTop = false, fromType = 0) {
		//   if (!this.validatenull(this.formUnit.insureConfirmFile) || this.validatenull(this.originData)) {
		//     return false
		//   }
		//   let {insureConfirmUrl = '', insureConfirmSample = ''} = this.originData
		//   if (insureConfirmUrl === '' || insureConfirmSample === '') {
		//     if (fromType === 0) {
		//       this.isZhangUnit = false
		//     } else {
		//       this.isZhangCalc = false
		//     }
		//     return false
		//   }
		//   if (fromType === 0) {
		//     this.isZhangUnit = true
		//   } else {
		//     this.isZhangCalc = true
		//   }
		//   this.downloadZhangFileUrl = insureConfirmUrl
		//   //展示盖章文件
		//   this.showInsureConfirmProp(true, insureConfirmSample)
		//   if (isShowHint) {
		//     this.$alert('根据规定：需要上传其他投保企业信息', '警告', {
		//       type: 'warning',
		//       confirmButtonText: '知道了'
		//     }).then(() => {
		//       //重新填写
		//       if (this.isSubmitted) {
		//         this.modifyUnit()
		//       }
		//       if (isNeedToTop) {
		//         this.$emit('onGoToTop')
		//       }
		//     })
		//   }
		//   return true
		// },
		//识别成功后处理
		checkOver() {
			//企业名称
			this.$message({
				message: '确认 成功',
				type: 'success',
			})
			this.optionUnit.column.forEach((itemData) => {
				itemData.disabled = true
			})
			this.isAbleUnitName = true
			this.optionUnit.submitBtn = false

			this.isSubmitted = true

			let submitData = this.getSubmitData()
			if (this.isNoYear) {
				//无法投年单
				submitData.isNoYear = true
			}
			this.$emit('onSubmitted', submitData)
			let {data: minEffDate = '', maxEffDate = ''} = this.originData
			if (minEffDate !== '' && maxEffDate !== '') {
				this.$Bus.$emit('onBusEffectiveData', {minEffDate, maxEffDate})
			}
		},

		modifyUnit() {
			this.optionUnit.submitBtn = true
			this.optionUnit.column.forEach((item, index) => {
				if (item.prop !== 'example') {
					item.disabled = false
				}
			})
			this.isSubmitted = false
			this.isAbleUnitName = false
			this.$emit('onUnsubmitted')
		},
		async uploadAfter(res, done, loading, column) {
			this.formUnit[column.prop] = res.url
			//根据URL 获取企业信息
			if (column.prop === 'license') {
				//人保直接上传数据
				if (this.insureType !== 29) {
					try {
						let result = await getUnitInfoByLicense(res.url)
						if (!result || result.data.code !== 0) {
							return
						}
						let {name = '', address = '', regNum = '', person = ''} = result.data.data || {}
						// }
						//校验企业信息
						this.formUnit.address = address
						this.formUnit.principal = person
						let {name: nameForm = '', code = ''} = this.formUnit
						if ((nameForm !== '' && nameForm !== name) || (code !== '' && code !== regNum)) {
							let hintText = [
								'营业执照识别数据与填写数据不匹配！',
								'识别数据：',
								`${name}，${regNum}`,
								'填写数据：',
								`${nameForm === '' ? '空' : nameForm}，${code === '' ? '空' : code}`,
							]
							const hintTextNew = []
							const H = this.$createElement
							for (let text in hintText) {
								hintTextNew.push(H('p', null, hintText[text]))
							}
							//识别结果不同
							this.$confirm(H('div', null, hintTextNew), '提示', {
								confirmButtonText: '自动替换',
								cancelButtonText: '手动修改',
							})
								.then(() => {
									this.formUnit.name = name
									this.formUnit.code = regNum
								})
								.catch(() => {})
						} else {
							this.formUnit.name = name
							this.formUnit.code = regNum
						}
					} catch (e) {
						this.$alert(e, '提示').then(() => {})
					} finally {
						done()
					}
				}
			}
			done()
		},
		searchBlur(e) {
			this.formUnit.name = e.target.value
		},
		getSubmitData() {
			let submitData = {
				unit_name: this.formUnit.name.replace(/\s*/g, ''),
				unit_code: this.formUnit.code,
				legal_person: this.formUnit.principal,
				legal_person_mobile: this.formUnit.mobile,
				area_code: this.formUnit.areaCode,
				unit_addr: this.formUnit.address,
				bus_license: this.formUnit.license,
			}
			if ((this.insureType === 14 || this.insureType === 29) && this.formUnit.certType === '100') {
				//阳光驾意险，并且为个人身份证
				submitData.unit_name = this.formUnit.name1
				submitData.unit_code = this.formUnit.code1
			}
			submitData.certType = this.formUnit.certType || ''

			if (isAnZeProduct(this.insureType)) {
				//安责
				if (this.insureType !== 18) {
					submitData.category = this.formUnit.category
					submitData.registerCapital = this.formUnit.registerCapital || ''
				} else {
					//安泽电梯
					submitData.industry = 'E'
					submitData.category = 5
					submitData.registerCapital = '200'
				}
				submitData.termType = this.formUnit.termType || ''
				//先判断
				let {termStart = '', termEnd = ''} = this.formUnit
				if (termStart !== '' && termStart.split('-').length !== 3) {
					this.formUnit.termStart = ''
				}
				if (termEnd !== '' && termEnd.split('-').length !== 3) {
					this.formUnit.termEnd = ''
				}

				submitData.termStart = this.formUnit.termStart || ''
				submitData.termEnd = this.formUnit.termEnd || ''
				let tempScope = this.formUnit.businessScope || ''
				if (!this.validatenull(tempScope) && tempScope.length > 40) {
					tempScope = tempScope.substring(0, 30)
				}
				submitData.businessScope = tempScope
				if (this.priceHintData.totalPrice >= 200000) {
					submitData.identityFront = this.formUnit.identityFront || ''
					submitData.identityBack = this.formUnit.identityBack || ''
				}
			}
			if (this.formUnit.email) {
				submitData.email = this.formUnit.email
			}
			// if (this.formUnit.insureConfirmFile) {
			//   submitData.InsureConfirm = this.formUnit.insureConfirmFile
			// }
			if (this.showIndustry) {
				submitData.industry = this.formUnit.industry
			}
			return submitData
		},
		getData() {
			if ((this.insureType === 14 || this.insureType === 29) && this.formUnit.certType === '100') {
				console.log(this.formUnit, '----1')
				//个人
				let {code1, name1, certType, areaCode} = this.formUnit
				return {
					code: code1,
					name: name1,
					certType,
					areaCode,
				}
			}
			return this.formUnit
		},
		setData(data) {
			if (!this.validatenull(data)) {
				this.formUnit.name = data.unit_name
				this.formUnit.code = data.unit_code
				this.formUnit.principal = data.legal_person
				this.formUnit.mobile = data.legal_person_mobile
				this.formUnit.areaCode = data.area_code
				// this.formUnit.insureConfirmFile = data.insureConfirmFile || ''

				this.formUnit.address = data.unit_addr
				this.formUnit.license = getImgUrl(data.bus_license)

				if (isAnZeProduct(this.insureType)) {
					this.formUnit.industry = data.industry || ''
					this.formUnit.category = data.category || ''
					this.formUnit.identityFront = data.identityFront || ''
					this.formUnit.identityBack = data.identityBack || ''

					this.formUnit.registerCapital = data.registerCapital || ''
					this.formUnit.termType = data.termType || ''
					this.formUnit.termStart = data.termStart || ''
					this.formUnit.termEnd = data.termEnd || ''
					this.formUnit.businessScope = data.businessScope || ''

					this.showCategoryProp(true)
				} else if (this.insureType === 13) {
					this.formUnit.email = data.email || ''
				} else if (this.insureType === 14 || this.insureType === 29) {
					if (this.insureType === 29) {
						data.certType = '100'
					}
					//阳光驾意险
					this.formUnit.certType = data.certType
					if (data.certType === '100') {
						//个人身份证
						this.formUnit.name1 = data.unit_name
						this.formUnit.code1 = data.unit_code
						this.formUnit.name = ''
						this.formUnit.code = ''
					}
				} else {
					if (this.showIndustry) {
						this.formUnit.industry = data.industry
						this.showIndustryProp(true)
					}
				}
			}
			this.loading = false
		},
		showIndustryProp(isShow) {
			this.optionUnit.column.forEach((item) => {
				if (item.prop === 'industry') {
					item.display = isShow
				}
			})
		},
		showCategoryProp(isShow) {
			if (!isShow) {
				return
			}
			this.optionUnit.column.forEach((item) => {
				if (item.prop === 'category') {
					item.display = isShow
				}
				if (item.prop === 'industry') {
					if (isShow && item.span !== 12) {
						item.span = 12
					}
					item.display = isShow
				}
			})
		},
		// showInsureConfirmProp(isShow = true, insureConfirmSample = '') {
		//
		//   let insureConfirmFile = this.findObject(this.optionUnit.column, 'insureConfirmFile')
		//   if (insureConfirmFile.display === isShow) {
		//     return
		//   }
		//   if (!isShow) {
		//     //隐藏记得删除
		//     this.formUnit.insureConfirmFile = ''
		//   }
		//   this.optionUnit.column.forEach((item) => {
		//     if (item.prop === 'insureConfirmFile') {
		//       item.display = isShow
		//     }
		//     if (item.prop === 'example123') {
		//       item.display = isShow
		//       this.formUnit.example123 = insureConfirmSample
		//     }
		//     if (item.prop === 'myDownLoadTemp') {
		//       item.display = isShow
		//     }
		//   })
		// },

		async onUploadBefore(fileData, done, loading) {
			let {type = '', size = 0, name} = fileData
			//人保
			if (this.insureType === 29) {
				//清理
				this.queryIdNoData = {}
				this.onClearInterval()
				let formData = new FormData()
				formData.append('files', fileData)
				formData.append('side', 'face')
				formData.append('idName', '')
				formData.append('batchld', '0')
				try {
					let result = (await uploadIdNoImg(formData)) || {}
					let {code = -1, data = {}} = result.data
					if (code === 0) {
						let {batchId = -1, files = []} = data
						if (files.length > 0) {
							this.formUnit.license = files[0].url
						}
						this.loading = true
						//循环调用获取身份证数据
						this.addIdNoInterval = setInterval(async () => {
							let resultAdd = (await addIdNoQuery(batchId)) || {}
							let {code: code1 = -1, data} = resultAdd.data
							if (code1 === 0) {
								let {emps = []} = data
								if (emps.length > 0 && emps[0].idno) {
									//成功啦！！！
									this.loading = false
									//清理
									this.onClearInterval()
									//进行校验！！！
									this.queryIdNoData = emps[0]
									this.onJudgeContent()
								}
							}
						}, 1000)
					}
				} catch (e) {
					this.$message.error('身份证照片识别失败，请重新上传！')
				} finally {
					loading()
				}
			} else {
				if (type !== 'image/jpeg' && type !== 'image/png') {
					this.$message.error('上传图片只支持JPEG或PNG格式!')
					loading()
					return
				}
				if (size / 1024 / 1024 > 5) {
					this.$message.error('请上传大小不超过5Mb的jpg/png文件')
					loading()
					return
				}
				done()
			}
		},
		//处理总价，显示身份证
		isJudgeShowCardImg(isShowCardImg = false) {
			//判断要显示普通数据
			this.optionUnit.column.forEach((itemData) => {
				let {prop, display} = itemData
				if (
					prop === 'registerCapital' ||
					prop === 'termType' ||
					prop === 'termStart' ||
					prop === 'termStart' ||
					prop === 'businessScope'
				) {
					if (!display) {
						itemData.display = true
					}
				}
			})
			let tempIndex = this.optionUnit.column.findIndex(({prop, display = false}) => {
				if (prop === 'identityFront' || prop === 'identityBack') {
					return display
				}
			})
			if (tempIndex === -1 && isShowCardImg) {
				this.$alert('根据规定：保费大于20万，则需要上传投保人负责人的身份证明', '提示', {
					type: 'warning',
					confirmButtonText: '知道了',
				}).then(() => {
					this.setCardImgDisplay(true)
					//重新填写
					if (this.isSubmitted) {
						this.modifyUnit()
					}
					//回到顶部
					this.$emit('onGoToTop')
				})
			} else if (tempIndex !== -1 && !isShowCardImg) {
				this.setCardImgDisplay()
			}
			//关于大于20万的身份证：投保人负责人的身份证明
		},
		setCardImgDisplay(isShowCadImg = false) {
			this.optionUnit.column.forEach((itemData) => {
				if (itemData.prop === 'identityFront' || itemData.prop === 'identityBack') {
					itemData.display = isShowCadImg
				}
			})
		},
		//设置信用代码规则
		setCodeRules() {
			this.optionUnit.column.forEach((itemData) => {
				// if (itemData.prop === 'code') {
				//   itemData.rules = [{
				//     required: true,
				//     validator: rule.validatorCreditCodeNotFifteen,
				//     trigger: 'blur'
				//   }]
				// }
				if (itemData.prop === 'industry') {
					itemData.dicData = industry_azx
				}
			})
			this.$nextTick(() => {
				if(this.$refs.formUnit){
					this.$refs.formUnit.updateDic()
				}
			})
		},
		//true 则需要显示
		isAnzeShowCustom(isShowCustom) {
			this.optionUnit.column.forEach((itemData) => {
				let {prop, display} = itemData
				//注册资本
				if (prop === 'registerCapital') {
					if (!display) {
						itemData.display = true
					}
					itemData.span = isShowCustom ? 12 : 24
				}
				if (prop === 'termType' || prop === 'termStart' || prop === 'businessScope') {
					if (!display && isShowCustom) {
						itemData.display = true
					} else if (display && !isShowCustom) {
						itemData.display = false
					}
				}
				//图片
				if (prop === 'identityFront' || prop === 'identityBack') {
					if (display) {
						itemData.display = false
					}
				}
			})
			let {termStart = '', termType = '', registerCapital = '', businessScope = ''} = this.formUnit
			//判断是否需要显示数据，并且之前请求数据为空
			if (isShowCustom) {
				if (
					this.validatenull(termStart) ||
					this.validatenull(termType) ||
					this.validatenull(registerCapital) ||
					this.validatenull(businessScope)
				) {
					//数据为空，则需要滚动到上面填写
					this.$alert('根据规定：需要上传其他投保企业信息', '提示', {
						type: 'warning',
						confirmButtonText: '知道了',
					}).then(() => {
						//重新填写
						if (this.isSubmitted) {
							this.modifyUnit()
						}
						//回到顶部
						this.$emit('onGoToTop')
					})
				}
			}
		},
		//下载模板
		onDownLoadTemp() {
			// let time = toYYYYmmdd(Date.now())
			// handleDownCustom(this.downloadZhangFileUrl, {}, `${time}-投保人声明盖章件（盖章模板).pdf`, 'get')
			openPdfUrl(this.downloadZhangFileUrl)
		},
		//处理数据填写
		onDealOptionYg() {
			let certType = this.findObject(this.optionUnit.column, 'certType')
			certType.display = true
			let address = this.findObject(this.optionUnit.column, 'address')
			address.row = true
		},
		onDealOptionRb() {
			// let certType = this.findObject(this.optionUnit.column, 'certType')
			// certType.display = true
			this.optionUnit.column.forEach((itemData) => {
				let {prop} = itemData
				if (prop === 'certType') {
					// itemData.display = false
					// itemData.disabled = true
					this.formUnit.certType = '100'
				}
				if (prop === 'name1' || prop === 'code1') {
					itemData.display = true
				}
				if (prop === 'name1') {
					itemData.label = '投保人'
					itemData.placeholder = '请输入 投保人姓名'
				}
				if (prop === 'license') {
					itemData.label = '身份证'
					itemData.rules[0].message = '请上传身份证图片'
				}
				//个人身份证
				if (prop === 'name' || prop === 'code' || prop === 'principal' || prop === 'example') {
					itemData.display = false
				}
			})
		},
		onDealChangeCertType(newVal) {
			this.optionUnit.column.forEach((itemData) => {
				let {prop} = itemData
				if (prop === 'name1' || prop === 'code1') {
					itemData.display = newVal === '100'
				}
				//个人身份证
				if (
					prop === 'name' ||
					prop === 'code' ||
					prop === 'principal' ||
					prop === 'areaCode' ||
					prop === 'address' ||
					prop === 'license' ||
					prop === 'example'
				) {
					itemData.display = newVal !== '100'
				}
			})
		},
		// //计算保费，需要盖章文件
		// onCalcNeedConfirmFile(originData) {
		//   //如果没有，则需要隐藏
		//   if (!originData.requiredInsureConfirm) {
		//     this.isZhangCalc = false
		//     if (!this.isZhangUnit) {
		//       //不需要
		//       this.showInsureConfirmProp(false)
		//     }
		//   } else {
		//     this.isZhangCalc = true
		//     //是否上传过
		//     this.isJudgeZhang(originData, true, 1)
		//   }
		// },
		onGetiSure() {
			//确认个体弹窗
			this.onCheckUnitResult()
		},
		//清理循环查询
		onClearInterval() {
			if (this.addIdNoInterval) {
				clearInterval(this.addIdNoInterval)
				this.addIdNoInterval = null
				this.loading = false
			}
		},
		onJudgeContent() {
			let {idno = '', name = '', address: address1 = ''} = this.queryIdNoData
			let {code1 = '', name1 = ''} = this.formUnit
			if (code1 !== '' || name1 !== '') {
				if (idno !== code1 || name !== name1) {
					let hintText = [
						'身份证识别数据与填写数据不匹配！',
						`识别数据：${name}，${idno}`,
						`填写数据：${name1 === '' ? '空' : name1}，${code1 === '' ? '空' : code1}`,
					]
					const hintTextNew = []
					const H = this.$createElement
					for (let text in hintText) {
						hintTextNew.push(H('p', null, hintText[text]))
					}
					//识别结果不同
					this.$confirm(H('div', null, hintTextNew), '提示', {
						confirmButtonText: '自动替换',
						cancelButtonText: '手动修改',
					})
						.then(() => {
							this.formUnit.name1 = name
							this.formUnit.code1 = idno
							this.formUnit.address = address1
							//地区身份证前六位
							if (idno.length > 6) {
								this.formUnit.areaCode = idno.substring(0, 6)
							}
						})
						.catch(() => {})
				}
			} else {
				this.formUnit.name1 = name
				this.formUnit.code1 = idno
				this.formUnit.address = address1
				//地区身份证前六位
				if (idno.length > 6) {
					this.formUnit.areaCode = idno.substring(0, 6)
				}
			}
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger {
	width: 150px;
	border: transparent;
}
</style>
